import { cn } from "@/lib/utils";

interface ModuleNumberBadgeProps {
  /** Leading module number from the title; omitted or empty renders nothing. */
  number?: string | null;
  /** When true, uses success color instead of brand secondary. */
  complete?: boolean;
  className?: string;
}

/**
 * Decorative module numeral in the TOC — sized to two title lines
 * (`text-[18px] leading-snug` in ModuleNode).
 */
const ModuleNumberBadge = ({
  number,
  complete = false,
  className,
}: ModuleNumberBadgeProps) => {
  if (!number) return null;

  return (
    <span
      aria-hidden="true"
      className={cn(
        "flex shrink-0 items-center justify-center self-stretch font-bold tabular-nums leading-none",
        "text-[calc(18px*1.375*2)]",
        complete ? "text-success" : "text-secondary",
        className
      )}
    >
      {number}
    </span>
  );
};

export default ModuleNumberBadge;
